import { useQuery } from '@tanstack/react-query'
import { outreachApi, outreachQueueQueryKey } from '../api'

export function useOutreachQueueQuery(startupId: string, queryOptions?: { enabled?: boolean }) {
  return useQuery({
    queryKey: outreachQueueQueryKey(startupId),
    queryFn: () => outreachApi.getQueue(startupId),
    ...queryOptions,
  })
}
